var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84654 5.05703C3.19029 5.23828 7.96529 7.84141 8.14342 7.93516C8.32154 8.02891 8.50279 8.07266 8.78404 8.07266C9.06529 8.07266 9.24654 8.02891 9.42467 7.93516C9.60279 7.84141 14.3778 5.23828 14.7215 5.05703C14.8497 4.99141 15.0653 4.87266 15.1122 4.73828C15.1934 4.50078 15.1059 4.41016 14.759 4.41016H2.80904C2.46217 4.41016 2.37467 4.50391 2.45592 4.73828C2.50279 4.87578 2.71842 4.99141 2.84654 5.05703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9945 5.19483C14.7383 5.32608 12.4383 6.96358 10.9164 7.94795L13.4852 10.8386C13.5477 10.9011 13.5758 10.9761 13.5414 11.0136C13.5039 11.048 13.4227 11.0292 13.357 10.9698L10.2758 8.36983C9.81016 8.66983 9.48203 8.87608 9.42578 8.90733C9.18516 9.0292 9.01641 9.04483 8.78516 9.04483C8.55391 9.04483 8.38516 9.0292 8.14453 8.90733C8.08516 8.87608 7.76016 8.66983 7.29453 8.36983L4.21328 10.9698C4.15078 11.0323 4.06641 11.0511 4.02891 11.0136C3.99141 10.9792 4.01953 10.9011 4.08203 10.8386L6.64766 7.94795C5.12578 6.96358 2.80078 5.32608 2.54453 5.19483C2.26953 5.0542 2.25391 5.21983 2.25391 5.34795V11.7542C2.25391 12.0448 2.68203 12.4073 2.98828 12.4073H14.582C14.8883 12.4073 15.2539 12.0417 15.2539 11.7542V5.34795C15.2539 5.2167 15.2727 5.0542 14.9945 5.19483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eef5cc84e54fd649f06308ead61fcfa7.svg";
export { ForwardRef as ReactComponent };